import React from 'react';
import { InformationCircleIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

interface Props {
  mode: 'recurrent' | 'week';
  onModeChange: (m: 'recurrent' | 'week') => void;
  disabled?: boolean;
}

/**
 * Replaces the legacy PlanningModeToggle. The "recurrent" state means
 * future changes apply to the template (all future weeks). "week" means
 * changes apply only to the displayed week's override.
 */
export const RecurringToggleCard: React.FC<Props> = ({ mode, onModeChange, disabled }) => {
  const isOn = mode === 'recurrent';

  return (
    <div className="pl-rd-card pl-rd-recur">
      <div className="pl-rd-recur-main">
        <h3 className="pl-rd-recur-title">
          Appliquer comme modèle récurrent
          <InformationCircleIcon className="pl-rd-info-icon" title="Si activé, vos modifications de planning sont enregistrées comme nouveau modèle et appliquées aux semaines suivantes." />
        </h3>
        <p className="pl-rd-recur-desc">
          {isOn
            ? 'Les modifications de cette semaine seront réutilisées pour les prochaines semaines.'
            : 'Les modifications resteront limitées à la semaine sélectionnée.'}
        </p>
        {isOn && (
          <div className="pl-rd-recur-confirm">
            <CheckCircleIcon className="w-4 h-4" />
            Activé : les changements seront appliqués aux semaines futures.
          </div>
        )}
      </div>

      <label className="pl-rd-switch" aria-label="Activer le modèle récurrent">
        <input
          type="checkbox"
          checked={isOn}
          disabled={disabled}
          onChange={e => onModeChange(e.target.checked ? 'recurrent' : 'week')}
        />
        <span className="pl-rd-switch-slider" />
      </label>
    </div>
  );
};
